// import { useEffect, useRef, useState } from "react";
import { useEffect, useRef, useState } from "react";
import Confetti from "react-confetti";
import "./App.scss";
import bgAudio from "./assets/bgAudio.mp3";
import deep from "./assets/deep.jpeg";
import dp from "./assets/dp.jpeg";
import wishes from "./assets/wishes.png";

function App() {
  const [count, setCount] = useState(0);
  const [show, setShow] = useState(false);
  const [showHappyBday, setShowHappyBday] = useState(false);
  const audioRef = useRef(new Audio(bgAudio));
  const btnRef = useRef();
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const cdata = [
    {
      sender: "from",
      msg: "Hi Sweetu",
      type: "text",
    },
    {
      sender: "to",
      msg: "Hello Lofer",
      type: "text",
    },
    {
      sender: "from",
      msg: "En madtidiya kane.",
      type: "text",
    },
    {
      sender: "to",
      msg: "enilla",
      type: "text",
    },
    {
      sender: "to",
      msg: "Neevu",
      type: "text",
    },
    {
      sender: "from",
      msg: "Nan sweetheart bagge",
      type: "text",
    },
    {
      sender: "from",
      msg: "nenskontha idini.",
      type: "text",
    },
    {
      sender: "from",
      msg: "😍😍😍",
      type: "emoji",
    },
    {
      sender: "to",
      msg: "Natka Madbedi😂",
      type: "text",
    },
    {
      sender: "to",
      msg: "ella sullu nimdu",
      type: "text",
    },
    {
      sender: "to",
      msg: "love ye illa",
      type: "text",
    },
    {
      sender: "from",
      msg: "yako ing heltiya😔",
      type: "text",
    },
    {
      sender: "from",
      msg: "eno madde sweetu nanu",
      type: "text",
    },
    {
      sender: "to",
      msg: "enu madtila adike",
      type: "text",
    },
    {
      sender: "from",
      msg: "sari ond pic kalsu",
      type: "text",
    },
    {
      sender: "to",
      msg: "illa illa",
      type: "text",
    },
    {
      sender: "from",
      msg: "Pls kano pls",
      type: "text",
    },
    {
      sender: "to",
      type: "image",
      src: deep,
    },
    {
      sender: "from",
      msg: "Sakathag idiya cutie",
      type: "text",
    },
    {
      sender: "from",
      msg: "Beautiful",
      type: "text",
    },
    {
      sender: "from",
      msg: "I love you so much sweetu",
      type: "text",
    },
    {
      sender: "to",
      msg: "nimig love ye illa",
      type: "text",
    },
    {
      sender: "to",
      msg: "ivath yav day?",
      type: "text",
    },
    {
      sender: "from",
      msg: "Nan yeg marithini?",
      type: "text",
    },
    {
      sender: "from",
      msg: "Ivath nan sweetheart du bday",
      type: "text",
    },
    {
      sender: "from",
      msg: "Happy Birthday sweetheart",
      type: "text",
    },
    {
      sender: "from",
      msg: "Yavathuu kushi ag iru",
      type: "text",
    },
    {
      sender: "from",
      msg: `I love you sweetheart ❤️. 
      Ivath nin first birthday nav ibru sari celebrate madana ❤️❤️ 
      ning ivath uu special day ne but nang idu best and memorable 
      da yak andre nav ibru sari celebrate mado best bday
      `,
      type: "text",
    },
    {
      sender: "from",
      msg: `Nav first meet madaga ist close agtiri antha gotirlila
      and ist ista padtivi anta gotirlia nan gotidre yavatho nina 
      hudukond bandu love madtide.❤️ I love you thumba sweetu.❤️`,
      type: "text",
    },
    {
      sender: "from",
      msg: `Nan nina thumba ista pattu preethi madtidini.id nan kai al agid ond chick surprise.
      ning ista aguto illvo nija nang gotila but idu thumba desa inda madtidini😄`,
      type: "text",
    },
    {
      sender: "from",
      msg: `Nan life al nina bitu yaru nan important illa neen nangoskara en enomadidiya.
      Devaru nam ibrge ond life kotre chenda iruthe. nav maduve agi ide tara yavaglu kushi kushi
      ag irbodu.`,
      type: "text",
    },

    {
      sender: "from",
      msg: `Wish you a very happy birthday kanaa🎂🎂🎁🎈🎉🎊`,
      type: "text",
    },
    {
      sender: "from",
      msg: `100 years chang iru`,
      type: "text",
    },
    {
      sender: "from",
      msg: `I love you so much`,
      type: "text",
    },
    {
      sender: "from",
      msg: `💘💖💕`,
      type: "emoji",
    },
    {
      sender: "to",
      msg: "Thanks Chinna 💖💖",
      type: "text",
    },
    {
      sender: "to",
      msg: "I LOVE YOU SO MUCH 💘",
      type: "text",
    },
    {
      sender: "from",
      msg: `I LOVE YOU TOO MUCH SWEETU.💖💖`,
      type: "text",
    },
  ];

  useEffect(() => {
    if (show) {
      const interval = setInterval(() => {
        if (count !== cdata.length - 1) {
          setCount((prev) => (cdata.length - 1 === prev ? prev : prev + 1));
        }
      }, 1500);

      return () => {
        if (count !== cdata.length - 1) {
          return clearInterval(interval);
        }
      };
    }
  }, [show]);

  useEffect(() => {
    scrollToBottom();
  }, [count, show]);

  const handleStart = () => {
    audioRef.current.play();
    setShow(true);
  };

  useEffect(() => {
    if (setShow) {
      const timer = setTimeout(() => {
        setShowHappyBday(true);
        setShow(false);
        setTimeout(() => {
          setShowHappyBday(false);
        }, 10000);
      }, 70000);
      return () => clearTimeout(timer);
    }
  }, [show]);

  return (
    <div className="app">
      <Confetti />
      <audio autoPlay={true} loop={true} id="audioElement" ref={audioRef}>
        <source src={bgAudio} type="audio/mp3" />
      </audio>
      {showHappyBday && (
        <div className="bday">
          <Confetti />
          <img src={wishes} alt="img" />
        </div>
      )}
      {show ? (
        <div className="wrapper">
          <div className="header">
            <img src={dp} className="header-img" alt={`bg-img`} />
            <div className="header-text">
              <p className="header-name">Daniel</p>
              <p className="header-online">Online</p>
            </div>
          </div>
          <div className="content">
            {cdata.map((d, i) => {
              if (i <= count) {
                if (d.type === "image") {
                  return (
                    <div key={i} className={`${d.sender} ${d.type}`}>
                      <img src={d.src} alt={`w-img-${i}`} />
                    </div>
                  );
                } else {
                  return (
                    <div key={i} className={`${d.sender} ${d.type}`}>
                      {d.msg}
                    </div>
                  );
                }
              } else {
                return null;
              }
            })}
            <div ref={messagesEndRef} />
          </div>
        </div>
      ) : (
        <div className="wrap">
          <div id="heart" onClick={() => handleStart()}></div>
          Start
        </div>
      )}
    </div>
  );
}

export default App;
